import {
	AssessmentTasks,
    AssessmentComplete
} from '../components/assessment';
import { taskSegment } from '../components/assessment/common/task-utility';

export const TaskRoutes = [
    { path: '/Assessment/Tasks/:type/:segment?/:index?', component: AssessmentTasks, monitorProgress: true },
    { path: `/Assessment/Tasks/:type/${taskSegment.TASKCOMPLETE}`, component: AssessmentTasks, monitorProgress: false }
];

export const AssessmentRoutes = [
    { path: '/Assessment/Complete', component: AssessmentComplete, monitorProgress: false },
    { path: '/Assessment/Timeout', component: AssessmentComplete, monitorProgress: false }
];